import { accentColor } from '../locatorDriftConstants';

export const resultsTabStyles = {
  loader: {
    color: accentColor,
  },
  metaRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2,
  },
  listPaper: {
    overflow: 'hidden',
  },
  stepRow: (isFail) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    p: 1.25,
    cursor: 'pointer',
    bgcolor: isFail ? '#fef2f2' : '#f0fdf4',
    borderBottom: '1px solid #e5e7eb',
    '&:hover': { filter: 'brightness(0.98)' },
  }),
  stepNumber: {
    width: 28,
    textAlign: 'right',
  },
  stepDescription: {
    flex: 1,
  },
  detailPanel: {
    p: 2,
    borderBottom: '1px solid #e5e7eb',
    bgcolor: '#fff',
  },
  detailTitle: {
    mb: 1,
  },
  detailAlert: {
    mb: 2,
  },
  detailValue: {
    wordBreak: 'break-all',
  },
};

export const resultsMetricColors = {
  passed: '#16a34a',
  failed: '#dc2626',
};
